import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Input, Bar } from '../../'

const InputRange = ({
  placeholder,
  label,
  min,
  max,
  step,
  onChange,
  value,
  ...props
}) => {
  return (
    <Fragment>
      <Input
        label={label}
        type='text'
        placeholder={placeholder}
        value={value}
      />
      <Bar
        type='range'
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={onChange}
      />
    </Fragment>
  )
}

InputRange.defaultProps = {
  onChange: /* istanbul ignore next */ () => null
}

InputRange.propTypes = {
  placeholder: PropTypes.string,
  label: PropTypes.string,
  min: PropTypes.string.isRequired,
  max: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}

export default InputRange
